<template>
  <div>
    <v-alert v-if="warnings.items.length" text icon="mdi-alert-outline" type="warning" class="ma-4">
      <div v-for="(warning, index) in warnings.items" :key="index" v-html="warning"></div>
    </v-alert>
    <v-card outlined shaped tile elevation="0" class="rounded-lg ma-4">
      <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="py-2 card-title-height">
          <v-btn icon elevation="0" class="" @click="showCard = !showCard">
            <v-icon color="white">
              {{
                showCard ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <div class="text-body-1 ml-2 white--text">{{ title }}</div>
          <v-spacer />
          <div v-if="!disabled">
            <v-btn v-if="!isEditing" color="white" icon @click="editMode()">
              <v-icon> mdi-pencil </v-icon>
            </v-btn>
            <v-btn v-else icon color="white" @click="viewMode()">
              <v-icon> mdi-eye </v-icon>
            </v-btn>
            <v-btn v-if="canAnonymise()" color="white" icon @click="anonymiseCustomerModal()">
              <v-icon> mdi-trash-can-outline </v-icon>
            </v-btn>
          </div>
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-if="loading">
          <v-progress-linear indeterminate color="primary" />
          <v-skeleton-loader class="mb-4" type="table-heading, table-tbody" />
          <v-skeleton-loader class="mb-4" type="table-heading, table:  button" />
        </div>
        <div v-else v-show="showCard">
          <v-card-text class="d-flex flex-wrap grey lighten-4">
            <ClientCardViewer
              v-if="!isEditing"
              key="viewCustomerForm"
              ref="viewCustomerForm"
              :content="content"
              :content-altered-values="contentAlteredValues"
            />
            <ClientCardForm
              v-if="isEditing"
              key="editCustomerForm"
              ref="editCustomerForm"
              :content="editableContent"
              :valid.sync="valid"
            />
          </v-card-text>
          <div v-if="isEditing">
            <v-divider />
            <v-card-text class="d-flex justify-end">
              <v-btn color="info" class="ml-4" @click="viewMode()">
                <v-icon class="mr-3">mdi-broom</v-icon>
                Annuler
              </v-btn>
              <v-btn :disabled="loading" color="secondary" elevation="0" class="mx-2 px-4" @click="saveValidCustomer()">
                <v-icon class="mr-3">mdi-content-save</v-icon>
                Enregistrer
              </v-btn>
            </v-card-text>
          </div>
        </div>
      </v-expand-transition>
    </v-card>
    <AnonymiseCustomerModal :uuid="content.uuid" />
  </div>
</template>

<script>
import ClientCardViewer from '@/components/profile/ClientCardViewer';
import ClientCardForm from '@/components/forms/ClientCardForm';
import AnonymiseCustomerModal from '@/components/profile/AnonymiseCustomerModal';

import { EventBus } from '../../mixins';

export default {
  name: 'ClientCard',
  components: { ClientCardViewer, ClientCardForm, AnonymiseCustomerModal },
  props: {
    errors: {
      type: Array,
      default: () => []
    },
    successes: {
      type: Array,
      default: () => []
    },
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentAlteredValues: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: 'Coordonnées principale'
    }
  },
  data () {
    return {
      loading: false,
      showCard: true,
      isEditing: false,
      editableContent: {},
      valid: false,
      warnings: {
        valid: true,
        items: []
      }
    };
  },
  mounted () {
    EventBus.$on('change-warnings', newWarnings => {
      this.clearEvents();
      this.warnings.valid = newWarnings.valid;
      this.warnings.items = newWarnings.warnings;
    });
  },
  methods: {
    canAnonymise () {
      return this.$store.state.user.roles.some(role => ['admin', 'ucpa_anonymize'].includes(role));
    },
    anonymiseCustomerModal () {
      EventBus.$emit('show-anon-modal');
    },
    async anonymiseCustomer () {
      EventBus.$emit('user-updated');
    },
    clearEvents () {
      EventBus.$emit('change-errors', []);
      EventBus.$emit('change-successes', []);
      this.warnings.valid = true;
      this.warnings.items = [];
    },
    editMode () {
      this.clearEvents();

      this.isEditing = true;
      this.editableContent = JSON.parse(JSON.stringify(this.content));
    },
    viewMode () {
      EventBus.$emit('change-errors', []);
      this.isEditing = false;
    },
    async saveEditedCustomer (newCustomer) {
      const success = await this.saveCustomer(newCustomer);

      this.loading = false;

      // this.identifiersLoading = false;
      if (success) {
        this.viewMode();
      }
    },
    async saveValidCustomer () {
      await this.$refs.editCustomerForm.validate();
      if (this.valid) {
        // if (!this.warnings.valid) {
        //   this.warnings.items = [];
        //   EventBus.$emit('change-errors', ['Un client avec cet email existe déjà']);
        //   return;
        // }
        this.loading = true;
        await this.saveEditedCustomer(this.editableContent);
      }
    }
  },
  onMounted () {
    EventBus.$on('anonymise-customer', () => {
      this.anonymiseCustomer();
    });
  },
};

</script>
